import styled from 'styled-components'

import { Media, spacing } from '../style'

const Wrapper = styled.div`
  width: 1200px;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  ${Media.lessThan(Media.small)} {
    width: auto;
    padding: 0 ${spacing.base};
  }
`

export default Wrapper
